module.exports = __webpack_public_path__ + "./docs/img/icon-facebook.b6c52aa9466cb270324aa7ef0f5c6ee6.svg";